import { SearchItemType } from "../StoreSearchInput/storeSearchInput.types";
import { StorePickerFilter } from "./types/storePickerFilter.enum";

export const STORE_PICKER_MESSAGE_ID = "store-picker-error";

export const STORE_PICKER_INPUT_TYPES = new Map<SearchItemType, number>([
    [SearchItemType.Store, 2],
    [SearchItemType.Locality, 3]
]);

export const STORE_PICKER_STORES_LIMIT = 9;

export const STORE_FILTERS = [
    StorePickerFilter.FILTER_EMPTY_STOCK,
    StorePickerFilter.FILTER_IS_OPEN
];
